export default __webpack_public_path__ + "static/media/editPencil.02ceb3de.svg";